export default __webpack_public_path__ + "static/media/license-icon.c3e4a147.svg";